import { Layout as AntLayout } from 'antd';
import React from 'react';
import { HeroSection } from '@components/Sections/HeroSection/HeroSection';
import { CoverageSection } from '@components/Sections/CoverageSection/CoverageSection';
import { TrustSection } from '@components/Sections/TrustSection/TrustSection';
import { NoHiddenFeesSection } from '@components/Sections/NoHiddenFeesSection/NoHiddenFeesSection';
import { FeaturesSection } from '@components/Sections/FeaturesSection/FeaturesSection';
import { CountryUseCasesSection } from '@components/Sections/FeaturesSection/CountryUseCasesSection';
import { ContactSalesSection } from '@components/Sections/ContactSalesSection/ContactSalesSection';
import SupportSection from '@components/Sections/SupportSection/SupportSection';
import { KeyFeaturesSection } from '@components/Sections/KeyFeaturesSection/KeyFeaturesSection';

export const HomeLayout = () => {
  return (
    <AntLayout className="min-h-screen bg-white overflow-x-hidden">
      <AntLayout.Content className="mt-[80px] mb-[30px] px-4 md:px-8 lg:px-16 ">
        <div className="flex justify-center ">
          <HeroSection />
        </div>
      </AntLayout.Content>

      <AntLayout.Content className="px-4 md:px-2 lg:px-8">
        <div className="flex justify-center mt-[60px]">
          <CoverageSection />
        </div>
        <div className="flex justify-center mt-[100px]">
          <TrustSection />
        </div>
        <div className="flex justify-center mt-[60px]">
          <NoHiddenFeesSection />
        </div>
        <div className="flex justify-center mt-[100px]">
          <CountryUseCasesSection />
        </div>
        <div className="flex justify-center mt-[100px] mb-[60px]">
          <FeaturesSection />
        </div>
        <div className="flex justify-center mt-[100px]">
          <KeyFeaturesSection />
        </div>
      </AntLayout.Content>
      <AntLayout.Content className="px-4 md:px-2 lg:px-8 bg-white ">
        <div className="flex justify-center mb-[60px] mt-[30px]">
          <SupportSection />
        </div>
      </AntLayout.Content>
      <ContactSalesSection />
    </AntLayout>
  );
};
